import authHeader from '../helpers/authHeader'
import { alertActions } from './alerts'
import { userActions } from './users'
import { history } from '../helpers/history'
import bcrypt from 'bcryptjs'

const ROOT_URL = '/api'

export const START_LOAD_EVENTS = 					'START_LOAD_EVENTS'
export const END_LOAD_EVENTS = 						'END_LOAD_EVENTS'
export const START_LOAD_EVENT = 					'START_LOAD_EVENT'
export const END_LOAD_EVENT = 						'END_LOAD_EVENT'
export const END_LOAD_EVENT_FAILURE =			'END_LOAD_EVENT_FAILURE'
export const UPDATE_EVENT = 							'UPDATE_EVENT'
export const UPDATE_EVENT_SUCCESS = 			'UPDATE_EVENT_SUCCESS'
export const UPDATE_EVENT_FAILURE = 			'UPDATE_EVENT_FAILURE'
export const ADMIN_UPDATE_EVENT = 				'ADMIN_UPDATE_EVENT'
export const ADMIN_UPDATE_EVENT_SUCCESS = 'ADMIN_UPDATE_EVENT_SUCCESS'
export const ADMIN_UPDATE_EVENT_FAILURE = 'ADMIN_UPDATE_EVENT_FAILURE'
export const SET_SELECTED_EVENT = 				'SET_SELECTED_EVENT'
export const SET_SELECTED_EVENT_SUCCESS = 'SET_SELECTED_EVENT_SUCCESS'
export const SET_SELECTED_EVENT_FAILURE = 'SET_SELECTED_EVENT_FAILURE'

export const eventActions = {
	startLoadEvents,
	endLoadEvents,
	loadEvents,
	loadEvent,
	setSelectedEvent,
	updateEvent,
	updateProfile,
	adminUpdateEvent
}

function startLoadEvents() {
	return {
		type: START_LOAD_EVENTS
	}
}

function endLoadEvents(eventsArray) {
	return {
		type: END_LOAD_EVENTS,
		eventsArray
	}
}

function updateEventSuccess(updatedEvent) {
	return {
    type: UPDATE_EVENT_SUCCESS,
    updatedEvent
  }
}

function updateEventFailure(error) {
	return {
    type: UPDATE_EVENT_FAILURE,
    error
  }
}

function loadEvents() {
	return (dispatch, getState) => {
		dispatch(startLoadEvents())

		const requestOptions = {
	    headers: authHeader(),
	  }

		return fetch(ROOT_URL + '/admin/events', requestOptions)
			.then(res => res.json())
			.then(
				res => {
					dispatch(endLoadEvents(res))
				},
				error => {
					console.log(error)
				})
			.catch((error) => {
				console.log(error)
			})
	}
}

function loadEvent(param) {
	return (dispatch) => {
		dispatch(startLoadEvent())

		let requestOptions = {}
		let path = `${ROOT_URL}/events/${param}/token`
		if (!param) {
			requestOptions['headers'] = authHeader()
			path = `${ROOT_URL}/events`
		}

		return fetch(path, requestOptions)
			.then(res => res.json())
			.then(
				res => {
					if (typeof res.error !== 'undefined') {
						dispatch(endLoadEventFailure(res))
					}
					else {
						dispatch(endLoadEvent(res))
					}
				},
				error => {
					console.log(error)
				})
			.catch((error) => {
				console.log(error)
			})
	}
}

function adminLoadEvent() {
	return (dispatch) => {
		dispatch(startLoadEvent())

		const requestOptions = {
			headers: authHeader(),
		}

		return fetch(ROOT_URL + '/admin/events', requestOptions)
			.then(res => res.json())
			.then(
				res => {
					dispatch(endLoadEvent(res))
				},
				error => {
					console.log(error)
				})
			.catch((error) => {
				console.log(error)
			})
	}
}

function startLoadEvent() {
	return {
		type: START_LOAD_EVENT
	}
}

function endLoadEvent(userEvent) {
	return {
		type: END_LOAD_EVENT,
		userEvent
	}
}

function endLoadEventFailure(userEvent) {
	return {
		type: END_LOAD_EVENT_FAILURE,
		userEvent
	}
}

function updateEvent(event) {
	return (dispatch) => {
		return fetch(ROOT_URL + `/events/${event.id}`, {
		  body: JSON.stringify({ event: event }),
      credentials: 'same-origin',
      headers: authHeader(),
      method: 'PUT',
		})
			.then(res => {
		    if (!res.ok) {
	        throw Error(res.statusText)
		    }
		    return res
			})
			.then(res => res.json())
			.then(res => {
				dispatch(updateEventSuccess(res))
				dispatch(loadEvent())
				dispatch(alertActions.success('Changes saved successfully'))
			})
			.catch(error => {
				dispatch(updateEventFailure(typeof error.message !== 'undefined' ? error.message : error))
				dispatch(loadEvent())
				dispatch(alertActions.error(typeof error.message !== 'undefined' ? error.message : error))
			})
	}
}

function updateProfile(event, user, cb) {
	return (dispatch) => {
		if (typeof user.password !== 'undefined' && user.password !== '') {
      user.password_digest = bcrypt.hashSync(user.password, 8)
    }
		let promises = [
	  	fetch(ROOT_URL + `/events/${event.id}`, {
			  body: JSON.stringify({ event: event }),
	      credentials: 'same-origin',
	      headers: authHeader(),
	      method: 'PUT',
			}),
			fetch(ROOT_URL + `/users/${user.id}`, {
				body: JSON.stringify({ user: user }),
	      credentials: 'same-origin',
	      headers: authHeader(),
	      method: 'PUT',
			}),
	  ]

	  let responseError = null

	  return Promise.all(promises)
			.then(res => {
				if (!res[0].ok || !res[1].ok) {
		    	// TODO: be more verbose about what the error is
		    	responseError = {eventResponse: res[0], userResponse: res[1]}
	        throw Error("Could not save profile")
		    }
		    return res
			})
			.then((res) => {
				return Promise.all([res[0].json(), res[1].json()])
			})
			.then((res) => {
				const eventResult = res[0]
	    	const userResult = res[1]
		  	dispatch(updateEventSuccess(eventResult))
				dispatch(userActions.updateUserSuccess(userResult))
				// If saving the form is successful go back to Dashboard
				if (cb) {
					cb()
				}
			})
			.catch(error => {
				window.ourError = error

				if (!responseError.eventResponse.ok) {
					responseError.eventResponse.json().then((errorJson) => {
						dispatch(updateEventFailure(errorJson))
					})
				}
				else {
					dispatch(updateEventSuccess(responseError.eventResponse))
				}

				if (!responseError.userResponse.ok) {
					responseError.userResponse.json().then((errorJson) => {
						dispatch(userActions.updateUserFailure(errorJson))
					})
				}
				else {
					dispatch(userActions.updateUserSuccess(responseError.userResponse.json()))
				}
			
				dispatch(alertActions.error(error))

			})
	}
}

function adminUpdateEvent(event) {
	return (dispatch) => {
		return fetch(ROOT_URL + `/admin/events/${event.id}`, {
		  body: JSON.stringify({ event: event }),
      credentials: 'same-origin',
      headers: authHeader(),
      method: 'PUT',
		})
			.then(res => res.json())
			.then(
				res => {
					dispatch(adminUpdateEventSuccess(res))
					dispatch(adminLoadEvent())
					dispatch(alertActions.success('Changes saved successfully'))
				},
				error => {
					dispatch(adminUpdateEventFailure(error))
					dispatch(adminLoadEvent())
					dispatch(alertActions.error(error))
				})
			.catch(error => {
				dispatch(adminUpdateEventFailure(error))
				dispatch(adminLoadEvent())
				dispatch(alertActions.error(error))
			})
	}
}

function adminUpdateEventSuccess(updatedEvent) {
	return {
    type: ADMIN_UPDATE_EVENT_SUCCESS,
    event: updatedEvent
  }
}

function adminUpdateEventFailure(error) {
	return {
    type: ADMIN_UPDATE_EVENT_FAILURE,
    error
  }
}

function setSelectedEvent(event) {
	return (dispatch) => {
		if (!event) {
			dispatch(setSelectedEventSuccess(null, null))
			return
		}

		const requestOptions = {
	    headers: authHeader(),
	  }

		return fetch(ROOT_URL + `/admin/users/${event.user_id}`, requestOptions)
			.then(res => res.json())
			.then(
				res => {
					dispatch(setSelectedEventSuccess(event, res))
				},
				error => {
					dispatch(setSelectedEventFailure(error))
				})
			.catch((error) => {
				dispatch(setSelectedEventFailure(error))
			})
	}
}

function setSelectedEventSuccess(event, user) {
	return {
		type: SET_SELECTED_EVENT_SUCCESS,
		selectedEvent: event,
		selectedUser: user
	}
}

function setSelectedEventFailure(error) {
	return {
    type: SET_SELECTED_EVENT_SUCCESS,
    error
  }
}
